import { T } from '@tribeplatform/react-components/i18n'

export const EmptyState = () => {
  return (
    <div className="text-sm text-content-subdued">
      <T
        defaultMessage="No {MEMBERS} to show here. Please review block settings."
        id="MemberBlock.EmptyState"
      />
    </div>
  )
}
